module.exports = __webpack_public_path__ + "media/images/pic/teachers/urszula-hellich-defd365d78236eee47d727ed70acbfcf.webp";